import { useNavigate } from "react-router-dom";

import { AppImage } from "components/AppImage/AppImage";
import { ContentWrapper, PaddingConfig } from "components/ContentWrapper";

import { mainLogo } from "utils/assets";

const LOGO_PADDING_CONFIG: PaddingConfig = {
  paddingBottom: 40,
  paddingLeft: 32,
  paddingRight: 32,
  paddingTop: 32,
};

export const Logo = (): JSX.Element => {
  const nvaigate = useNavigate();

  const onClickLogo = () => nvaigate("/");

  return (
    <ContentWrapper paddingConfig={LOGO_PADDING_CONFIG}>
      <AppImage
        src={mainLogo}
        onClick={onClickLogo}
        className="cursor-pointer"
      />
    </ContentWrapper>
  );
};
